export default __webpack_public_path__ + "static/media/BuenFin23(360x600).23380fc5.webp";